import Axios from 'axios';

import { BaseLogger, Log, LoggerLevel } from '$/common/lib/logger';

/**
 * Generic Teams logger that sends messages to Teams via webhook
 */
export class MSTeamsLogger extends BaseLogger {

	private webhookUrl: string;
	private formatPayload: (log: Log) => string;

	constructor(webhookUrl: string, formatPayload: (log: Log) => string) {
		super();
		this.webhookUrl    = webhookUrl;
		this.formatPayload = formatPayload;
	}

	async log(...args) {
		const logs = super.log.apply(this, args);

		for (const log of logs) {
			if (log.level === LoggerLevel.Command) {
				continue;
			}

			void Axios.post(this.webhookUrl, { message : this.formatPayload(log) }, { headers : { 'Content-Type' : 'application/json' } });
		}

		return logs;
	}

}
